import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResultInfoGenericDto } from '../dto/ResultInfoDto';
import { FormToJsonBlService } from './form-to-json-bl.service';
import { CreateResultDto } from '../dto/create-result-dto';

@Injectable({
  providedIn: 'root'
})
export class ZadostPopService {

  constructor(
    private http: HttpClient,
    private formToJsonBlService: FormToJsonBlService
  ) { }

  private apiZadostPopCreate: string = "api/ZadostPop/Create";
  private apiZadostPopGet: string = "api/ZadostPop/Get";

  /**
   * Vytvoří novou žádost o POP.
   * @param jsonData
   */
  createNew(jsonData: any): Observable<ResultInfoGenericDto<CreateResultDto>> {
    let jsonString = this.formToJsonBlService.convert(jsonData);
    let httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
    return this.http.post<ResultInfoGenericDto<CreateResultDto>>(this.apiZadostPopCreate, jsonString, httpOptions);
  };

  /**
   * Vrátí dto foprmuláře
   * @param zadostId
   * @param token
   */
  get(zadostId: number, token: string): Observable<ResultInfoGenericDto<any>> {
    return this.http.get<ResultInfoGenericDto<any>>(this.apiZadostPopGet + "/" + zadostId + "/" + token);
  };
}
